import { Link, } from "react-router-dom";
import React from "react";

const Title = () => {
  return (
    <div className="title section">
     
     <Link to="/">Title</Link>
      <br />
      <Link to="/top">Top</Link>
      <br />
      <Link to="/category">category</Link>
    </div>
  );
};

export default Title;
